// ----------------------------------------------------------------------

/**
 * 앱 다크 모드(MUI palette mode 'dark')에서 MUI 는 떠 있는 Paper(Dialog · Popover · Menu)에
 * 높이(elevation)만큼 흰 그라디언트를 얹어 회색으로 만든다 — 앱 네이티브 다크와 톤이 달라지므로 끈다.
 * 라이트에서는 원래 그라디언트가 없어 화면 변화 없음.
 */
export default function Paper() {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        // 다이얼로그 바탕은 화면 바탕과 같은 색 — 안쪽 구분 띠(bg-subtle)가 보이게
        paper: {
          backgroundColor: 'var(--dk-bg, #FFFFFF)',
        },
      },
    },
  };
}
